import { TreeStructureIcon as PhosphorTreeStructureIcon } from "@phosphor-icons/react/dist/ssr/TreeStructure";

import { createAppIcon } from "@/components/createAppIcon";

export const HierarchyIcon = /* @__PURE__ */ createAppIcon(PhosphorTreeStructureIcon);
